import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetGroupViewItem } from 'edu-application/dist/groups/get-groups/get-group.viewmodel'
import { environment } from 'src/environments/environment';
import { OrganizationService } from '../translator/organization.service';
@Injectable({
  providedIn: 'root'
})
export class GroupsService {
  private static groups : GetGroupViewItem[];
  constructor(private _http : HttpClient, private _organizationService: OrganizationService) { }

  async getGroups() : Promise<GetGroupViewItem[]>{
    if(GroupsService.groups == null) {
      GroupsService.groups = await this._http.get<GetGroupViewItem[]>(`${environment.backend_url}/groups/${this._organizationService.getOrganizationId()}`).toPromise();
    }
    return GroupsService.groups;
  }
}
